import api from './api';

const forecastService = {
  // Get all forecasts with optional filters
  getAll: async (params = {}) => {
    const response = await api.get('/forecasts', { params });
    return response.data;
  },

  // Get single forecast by ID
  getById: async (id) => {
    const response = await api.get(`/forecasts/${id}`);
    return response.data;
  },

  // Create new forecast
  create: async (forecastData) => {
    const response = await api.post('/forecasts', forecastData);
    return response.data;
  },

  // Update forecast
  update: async (id, forecastData) => {
    const response = await api.put(`/forecasts/${id}`, forecastData);
    return response.data;
  },

  // Delete forecast
  delete: async (id) => {
    const response = await api.delete(`/forecasts/${id}`);
    return response.data;
  },

  // Get forecast statistics
  getStatistics: async (projectId = null) => {
    const params = projectId ? { project_id: projectId } : {};
    const response = await api.get('/forecasts/statistics', { params });
    return response.data;
  },

  // Get forecast trends
  getTrends: async (params = {}) => {
    const response = await api.get('/forecasts/trends', { params });
    return response.data;
  }
};

export default forecastService;

